/**
 * Utility functions for user-related operations
 */

/**
 * Get initials from a person's name
 * @param name - Full name string
 * @returns Two-letter initials in uppercase (e.g., "John Doe" -> "JD")
 */
export const getInitials = (name: string): string => {
  if (!name || name.trim().length === 0) return '??';
  
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .substring(0, 2);
};
